import { TagManagerArgs } from "react-gtm-module";
import { IGtmData } from "src/types/layout";
import { emptyToUndefined } from "src/utils/common-util";

function sanitizeUserData(userData: IGtmData["userData"]): IGtmData["userData"] | undefined {
    const sha256EmailAddress = emptyToUndefined(userData?.sha256_email_address);

    return { sha256_email_address: sha256EmailAddress };
}

export function initGtm(data: IGtmData): TagManagerArgs {
    const sanitizedUserData = sanitizeUserData(data.userData);

    return {
        gtmId: data.gtmId,
        dataLayer: {
            countryMode: emptyToUndefined(data.countryMode),
            languageMode: emptyToUndefined(data.languageMode),
            userID: emptyToUndefined(data.userId),
            UserSegment: data.userSegment,
            TraderLifecyclePosition: data.traderLifecyclePosition,
            CustomerLifecyclePosition: data.customerLifecyclePosition,
            WikifolioShortDescription: emptyToUndefined(data.wikifolio?.wikifolioShortDescription),
            WikifolioIsin: emptyToUndefined(data.wikifolio?.wikifolioIsin),
            UserData: sanitizedUserData,
        },
    };
}
